const tagTypeMapper = {
  confirmed: 'success',
  pending: 'warning',
  expired: 'disabled',
  cancelled: 'disabled',
  unknown: 'neutral',
  open: 'warning',
  quote: 'important',
  denied: 'danger',
};

const taskStatus = {
  inProgress: 'in_progress',
  completed: 'completed',
  failed: 'failed',
};

const ancillariesKey = {
  seat: 'seats',
  service: 'services',
};

const STATUS_OPEN = 'open';
const STATUS_CONFIRMED = 'confirmed';
const STATUS_ISSUED = 'issued';
const STATUS_PENDING = 'pending';
const STATUS_VOIDED = 'voided';
const STATUS_QUOTE = 'quote';
const STATUS_CANCELLED = 'cancelled';
const STATUS_EXPIRED = 'expired';
const STATUS_REFUND_REQUESTED = 'refund_requested';
const STATUS_REFUNDED = 'refunded';
const UTC = 'UTC';
const POLLING_TIMEOUT = 5000;
const INITIAL_ANCILLARY_DISPLAY_COUNT = 1;

export {
  tagTypeMapper,
  taskStatus,
  STATUS_OPEN,
  STATUS_CONFIRMED,
  STATUS_ISSUED,
  STATUS_PENDING,
  STATUS_VOIDED,
  STATUS_QUOTE,
  STATUS_CANCELLED,
  STATUS_EXPIRED,
  STATUS_REFUND_REQUESTED,
  STATUS_REFUNDED,
  UTC,
  POLLING_TIMEOUT,
  ancillariesKey,
  INITIAL_ANCILLARY_DISPLAY_COUNT,
};
